import React from "react";
import "../../styles/Footer.scss";
const Footer = () => {

    const handleTermsClick = () => {
        window.open('https://www.se-fi.com/terms-of-use');
    }

    const handlePrivacyPolicyClick = () => {
        window.open('https://www.se-fi.com/privacy-policy');
    }
    return (
        <React.Fragment>
            <div className="footer-container">
                <div className="footer">
                    <span className="footer-content">©{new Date().getFullYear()} PCMI, LLC. All rights reserved.</span>
                    <div>
                        <span data-testid="termsOfUse" className="terms-content" onClick={() => { handleTermsClick(); }}>Terms of Use</span>
                        <span data-testid="privacy-policy" className="terms-content privacy-content" onClick={() => { handlePrivacyPolicyClick(); }}>Privacy Policy</span>
                    </div>
                </div>
                <div className="information-text">
                    PCMI, LLC. does not store your data. Any information collected on this form is sent directly to the claims company.
                </div>
            </div>
        </React.Fragment>
    );
};

export default Footer;
